export const T = {
  en_GB: {
    currentPlan: "Current Plan",
    users: "users",
    perUserMonth: "per user/month",
    minLicenses: "Minimum licenses",
    contactSales: "Contact sales",
    subscribe: "Subscribe",
    changePlan: "Change Plan",
    changeSeats: "Change Seats",
    current: "Current",
    cancelSubscription: "Cancel Subscription",
    cancelConfirm:
      "Are you sure you want to cancel? Your plan will remain active until the end of the billing period.",
    resumeSubscription: "Resume Subscription",
    changeCard: "Change Card",
    // Basic tier
    basicName: "Basic",
    basicPrice: "€100",
    basicFeature1: "Max 1 admin user",
    basicFeature2: "500 monthly API calls",
    basicFeature3: "Self-service onboarding",
    basicFeature4: "Support via tickets (no SLA)",
    // Business tier
    businessName: "Business",
    businessPrice: "€130",
    businessFeature1: "Up to 5 admin users",
    businessFeature2: "3,000 monthly API calls",
    businessFeature3: "Standardized onboarding",
    businessFeature4: "8 work hours response time",
    businessFeature5: "Customer Success Manager",
    businessFeature6: "SSO, Client Access, Audit Log",
    // Enterprise tier
    enterpriseName: "Enterprise",
    enterprisePrice: "Custom",
    enterpriseFeature1: "Unlimited admin users",
    enterpriseFeature2: "Unlimited API calls",
    enterpriseFeature3: "Extended onboarding",
    enterpriseFeature4: "2 work hours response time",
    enterpriseFeature5: "Dedicated CSM",
    enterpriseFeature6: "Custom integrations",
    // Payment info
    paymentMethod: "Payment Method",
    noPaymentMethod: "No payment method on file",
    expires: "Expires",
    active: "Active",
    pending: "Pending",
    cancelled: "Cancelled",
    pastDue: "Past Due",
    noSubscription: "No Subscription",
    cancelsOn: "Cancels on",
    // Checkout dialog
    subscribeTo: "Subscribe to",
    changeTo: "Change to",
    seats: "Number of seats",
    removeSeat: "Remove a seat",
    addSeat: "Add a seat",
    minSeats: "Minimum seats for this tier",
    monthlyTotal: "Monthly total",
    dueToday: "Due today (prorated)",
    startingNextMonth: "Starting next month",
    cancel: "Cancel",
    proceedToPayment: "Proceed to Payment",
    confirmChange: "Confirm Change",
    processing: "Processing...",
    // Test mode
    testModeTitle: "Test Mode",
    testModeDescription: "Mollie is in test mode. Use these test cards to simulate payments:",
    testCardVisa: "Visa",
    testCardMastercard: "Mastercard",
    testCardAmex: "American Express",
    testCardExpiry: "Expiry: Any future date",
    testCardCvc: "CVC: Any 3 digits",
    aiUsageNote:
      "You will also be charged for your metered usage using this card. View your usage at",
    aiUsageLink: "Metered Usage Dashboard",
  },
  nb_NO: {
    currentPlan: "Gjeldende plan",
    users: "brukere",
    perUserMonth: "per bruker/måned",
    minLicenses: "Minimum lisenser",
    contactSales: "Kontakt salg",
    subscribe: "Abonner",
    changePlan: "Endre plan",
    changeSeats: "Endre antall seter",
    current: "Gjeldende",
    cancelSubscription: "Avslutt abonnement",
    cancelConfirm:
      "Er du sikker på at du vil avslutte? Planen din forblir aktiv til slutten av faktureringsperioden.",
    resumeSubscription: "Gjenoppta abonnement",
    changeCard: "Endre kort",
    // Basic tier
    basicName: "Basic",
    basicPrice: "€100",
    basicFeature1: "Maks 1 admin-bruker",
    basicFeature2: "500 månedlige API-kall",
    basicFeature3: "Selvbetjent onboarding",
    basicFeature4: "Support via saker (ingen SLA)",
    // Business tier
    businessName: "Business",
    businessPrice: "€130",
    businessFeature1: "Opptil 5 admin-brukere",
    businessFeature2: "3000 månedlige API-kall",
    businessFeature3: "Standardisert onboarding",
    businessFeature4: "8 arbeidstimers responstid",
    businessFeature5: "Customer Success Manager",
    businessFeature6: "SSO, Kundetilgang, Revisjonslogg",
    // Enterprise tier
    enterpriseName: "Enterprise",
    enterprisePrice: "Tilpasset",
    enterpriseFeature1: "Ubegrensede admin-brukere",
    enterpriseFeature2: "Ubegrensede API-kall",
    enterpriseFeature3: "Utvidet onboarding",
    enterpriseFeature4: "2 arbeidstimers responstid",
    enterpriseFeature5: "Dedikert CSM",
    enterpriseFeature6: "Tilpassede integrasjoner",
    // Payment info
    paymentMethod: "Betalingsmetode",
    noPaymentMethod: "Ingen betalingsmetode registrert",
    expires: "Utløper",
    active: "Aktiv",
    pending: "Venter",
    cancelled: "Avsluttet",
    pastDue: "Forfalt",
    noSubscription: "Ingen abonnement",
    cancelsOn: "Avsluttes",
    // Checkout dialog
    subscribeTo: "Abonner på",
    changeTo: "Endre til",
    seats: "Antall seter",
    removeSeat: "Fjern et sete",
    addSeat: "Legg til et sete",
    minSeats: "Minimum seter for dette nivået",
    monthlyTotal: "Månedlig totalt",
    dueToday: "Forfaller i dag (proratert)",
    startingNextMonth: "Fra neste måned",
    cancel: "Avbryt",
    proceedToPayment: "Gå til betaling",
    confirmChange: "Bekreft endring",
    processing: "Behandler...",
    // Test mode
    testModeTitle: "Testmodus",
    testModeDescription: "Mollie er i testmodus. Bruk disse testkortene for å simulere betalinger:",
    testCardVisa: "Visa",
    testCardMastercard: "Mastercard",
    testCardAmex: "American Express",
    testCardExpiry: "Utløp: Hvilken som helst fremtidig dato",
    testCardCvc: "CVC: Hvilke som helst 3 siffer",
    aiUsageNote: "Du vil også bli belastet for målt bruk med dette kortet. Se din bruk på",
    aiUsageLink: "Forbruksoversikt",
  },
} as const;
